// extracted by mini-css-extract-plugin
export default {"header":"Header_header__sTg4h","img":"Header_img__KKG8v","app-title":"Header_app-title__Jpdiu","userdiv":"Header_userdiv__-wtfl"};